export const HOME_INCOME: {
    [s: string]: string;
} = {
    '1': '200万円未満', '2': '200-300万円未満', '3': '300-400万円未満',
    '4': '400-500万円未満', '5': '500-600万円未満', '6': '600-700万円未満',
    '7': '700-800万円未満', '8': '800-900万円未満', '9': '900-1000万円未満',
    '10': '1000-1500万円未満', '11': '1500-2000万円未満', '12': '2000-2500万円未満',
    '13': '2500-3000万円未満', '14': '3000万円以上',
    // '15': 'わからない', '0': '無回答'
};